/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './PriorCurrentProjectsComponent.module.scss';
import metadata from './PriorCurrentProjectsComponent.metadata.json5';

function PriorCurrentProjectsComponent(props) {

    const {
        data: PriorCurrentProjectsVM,
        updateWizardData,
        submissionVM,
        PriorCurrentProjectsPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addPriorCurrentProjects = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PriorCurrentProjectsVM.value = PriorCurrentProjectsVM.value || []

            const { _xCenter, _dtoName } = PriorCurrentProjectsVM;

            const PriorCurrentProjectsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PriorCurrentProjectsVM.pushElement(
                PriorCurrentProjectsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PriorCurrentProjectsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PriorCurrentProjectsVM.value.splice(index, 1);
            _.set(submissionVM.value, PriorCurrentProjectsPath, PriorCurrentProjectsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PriorCurrentProjectsPath, PriorCurrentProjectsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'proNam1') {
                const value = item.proNam1 ? item.proNam1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.proNam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des2') {
                const value = item.des2 ? item.des2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'sinLarConProVal3') {
                const value = item.sinLarConProVal3 ? item.sinLarConProVal3 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.sinLarConProVal3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PriorCurrentProjectsTable`]: {
            data: PriorCurrentProjectsVM.value,
        }

    }), [PriorCurrentProjectsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPriorCurrentProjects,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PriorCurrentProjectsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PriorCurrentProjectsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PriorCurrentProjectsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PriorCurrentProjectsComponent.propTypes = wizardProps;
export default withRouter(PriorCurrentProjectsComponent);
